import CtaButtons from '../CtaButtons'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { RolexStorePageV72024 } from '@lib/kontent/models/RolexStorePageV72024'
import { FC } from 'react'

type Props = {
  retailer: RolexStorePageV72024
}

const Retailer: FC<Props> = ({ retailer }) => {
  return (
    <div className="flex flex-col items-center justify-center bg-white p-8 text-center">
      <LocalizedLink href={`/rolex/contact/${retailer.url_slug.value}`} passHref>
        <a>
          <Text variant="legend16" className="mb-2 text-rolexBrown">
            Rolex official retailer
          </Text>
          <Heading variant="headline26" className="mb-5  text-rolexBrown">
            {retailer.name.value}
          </Heading>

          <Text variant="fixed16" weight="light" className="mb-5 leading-[1.6]">
            {retailer.address_details.value}
          </Text>
        </a>
      </LocalizedLink>
      <CtaButtons
        showLabel={false}
        className="!flex-row"
        phoneNumber={retailer.phone_number.value}
        directionsUrl={retailer.google_maps_link.value}
        detailSlug={retailer.url_slug.value}
      />
    </div>
  )
}

export default Retailer
